import React, { useCallback, useState } from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { FormViewer, FormViewerHandle } from '@wix/form-viewer/widget';
import {
  FormError,
  FormStatus as WixFormStatus,
  FormValues,
  FORM_STATUS,
} from '@wix/form-viewer';
import { WaiverForms, WaiverFormStatus } from '../../../../types/form-types';
import { classes } from './WaiverForm.st.css';

export interface WaiverFormProps {
  formId: string;
  waiverForms: WaiverForms;
  formValues: FormValues;
  handleFormChange: (values: FormValues) => void;
  waiverFormRef: React.RefObject<FormViewerHandle>;
  onStatusChange?: (status: WaiverFormStatus) => void;
}

const WaiverForm: React.FC<WaiverFormProps> = ({
  formId,
  formValues,
  handleFormChange,
  waiverFormRef,
  waiverForms,
  onStatusChange,
}) => {
  const { i18n } = useTranslation();
  const [formErrors, setFormErrors] = useState<FormError[]>([]);

  const handleFormValidate = useCallback((errors: FormError[]) => {
    setFormErrors(errors);
  }, []);

  const handleStatusChanged = useCallback(
    (status: WixFormStatus) => {
      if (status === FORM_STATUS.BUSY) {
        onStatusChange?.(WaiverFormStatus.VALIDATING);
      } else {
        onStatusChange?.(WaiverFormStatus.IDLE);
      }
    },
    [onStatusChange],
  );

  return (
    <div data-hook="WaiverForm-main" className={classes.root}>
      <FormViewer
        onStatusChange={(status) => handleStatusChanged(status)}
        onChange={handleFormChange}
        onValidate={handleFormValidate}
        values={formValues}
        errors={formErrors}
        i18n={i18n}
        formId={formId}
        ref={waiverFormRef}
        overrides={waiverForms.overrides}
      />
    </div>
  );
};

export default WaiverForm;
